export default __webpack_public_path__ + "static/media/iol-logo.50195be8.svg";